import { M3PDinamByActividad } from "./m3-pdinam-by-actividad";

export class M3PEnvios{
    public IdEnvio:number;
    public IdFormaEnvio:number;
    public NombreFEnvio:string;
    public Direccion:string;
    public Pais:string;
    public Ciudad:string;
    public M3PDinamByActividad = new Array<M3PDinamByActividad>();
}